import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
    cabecalho: {
        marginBottom: theme.spacing(2)
    },
    linha: {
        wordBreak: 'break-word'
    },
    rotulo: {
        fontWeight: 500
    },
    corpo: {
        display: 'block',
        width: '100%',
        height: 320,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius
    }
}));

/* "Nome <email>", só o que existir. */
const endereco = (nome, email) => (nome && email ? `${nome} <${email}>` : (email || nome || ''));

/*
 * Prévia de um e-mail: cabeçalho (De / Para / Cópia, quando informados, e
 * Assunto) e o corpo HTML num iframe com `sandbox` vazio — o HTML é mostrado,
 * mas nenhum script é executado.
 */
export default function PreviaEmail(props) {
    const {remetente, nomeDestinatario, emailDestinatario, assunto = '', corpo = ''} = props;
    const classes = useStyles();

    const linhas = [
        remetente ? {rotulo: 'De', valor: endereco('centralbolsas', remetente)} : null,
        nomeDestinatario || emailDestinatario ? {rotulo: 'Para', valor: endereco(nomeDestinatario, emailDestinatario)} : null,
        remetente ? {rotulo: 'Cópia', valor: `${remetente} (cópia enviada ao e-mail do campus)`} : null,
        {rotulo: 'Assunto', valor: assunto}
    ].filter(Boolean);

    return (
        <>
            <div className={classes.cabecalho}>
                {linhas.map(linha => (
                    <Typography key={linha.rotulo} variant='body2' className={classes.linha}>
                        <span className={classes.rotulo}>{`${linha.rotulo}: `}</span>
                        {linha.valor}
                    </Typography>
                ))}
            </div>
            <iframe title='Prévia do e-mail' srcDoc={corpo} sandbox='' className={classes.corpo}/>
        </>
    );
}

PreviaEmail.propTypes = {
    /* E-mail remetente do processo (também recebe a cópia). */
    remetente: PropTypes.string,
    nomeDestinatario: PropTypes.string,
    emailDestinatario: PropTypes.string,
    assunto: PropTypes.string,
    /* Corpo do e-mail (HTML). */
    corpo: PropTypes.string
};
